<div class="grid grid-cols-2 gap-2">
  @if (!loading) {
    @if (previews.length > 0) {
      @for (preview of previews; track $index) {
        <div class="aspect-square bg-gray-100 flex items-center justify-center overflow-hidden rounded shadow-md"
             [class.cursor-pointer]="preview.thumbUrl"
             (click)="preview.thumbUrl && viewerIndex.set($index)">
          @if (preview.thumbUrl) {
            <img [src]="preview.thumbUrl"
                 [alt]="'Photo ' + ($index + 1)"
                 class="object-cover w-full h-full" />
          } @else {
            <span class="text-xs text-gray-400">No photo</span>
          }
        </div>
      }
    } @else {
      <div class="col-span-2 text-center p-4">
        No photos available
      </div>
    }
  } @else {
    @for (i of [1,2,3,4]; track i) {
      <div class="aspect-square bg-gray-200 animate-pulse rounded shadow-md">
      </div>
    }
  }
</div>

<!-- Tiles are the first photos, so a tile's $index is also its index in photos() -->
@if (viewerIndex() !== null) {
  <app-photo-viewer [photos]="photos()" [startIndex]="viewerIndex()!" (close)="viewerIndex.set(null)" />
}
